
import { Proc } from "./proc";
// import Providers from './providers.js';

import APPLICATION from './providers/application.provider'
import AUTH from './providers/auth.provider'
import ROUTER from './providers/router.provider'
import STATUSBAR from './providers/statusBar.provider'
import SETTING from './providers/setting.provider'

import MOCK from './providers/mock.provider'
import MQTT from './providers/mqtt.provider'
import DPC from './providers/dpc.provider'
import WIDGET from './providers/widget.provider'
import TECHNOLOGY from './providers/technology.provider'
import TECHNOLOGYTOPO from './providers/technology-topo.provider'
import OPERATION from './providers/operation.provider'
import SHEET from './providers/sheet.provider'
import VUECOMPONENTSPROVIDER from './providers/vueComponentsProvider.provider'
import Editor from "./providers/editor.provider";



/**
 * provider枚举名称
 * 注意先后顺序
 * @readonly
 * @enum {string}
 */
const PackageNames = {
    'Application': 'Application',
    'Auth': 'Auth',
    'Router': 'Router',
    'StatusBar': 'StatusBar',
    'Setting': 'Setting',
    'Mock': 'Mock',
    'MQTT': 'MQTT',
    'DPC': 'DPC',
    'Widget': 'Widget',
    'Technology': 'Technology',
    'TechnologyTopo': 'TechnologyTopo',
    'Operation': 'Operation',
    'Sheet': 'Sheet',
    'VueCustomElement': 'VueCustomElement',
    'Editor': 'Editor',
}

// 通信进程

class CORE extends Proc {

    constructor() {
        super()
        // 初始化
        for (let [key, provider] of this.providers.entries()) {
            this.providers.set(key, new provider(this))
        }
    }
    /**
     * @type {APPLICATION}
     */
    Application

    booted = true;
    /**
    * 供provider访问其他内部的provider，同在外部使用getProvider方法一样,内部也可以使用getProvider方法，此方法为兼容旧版本
    * @param {String} name provider名称
    * @returns { provider }
    */
    make(name) {
        if (!this.hasProvider(name)) {
            throw new Error(`provider ${name} is not registered`);
        }

        return this.providers.get(name);
    }

    providerTypes = PackageNames;

    /**
     * 获取providers
     */
    providers = new Map([

        [PackageNames.Application, APPLICATION],
        [PackageNames.Auth, AUTH],
        [PackageNames.Router, ROUTER],
        [PackageNames.StatusBar, STATUSBAR],
        [PackageNames.Setting, SETTING],
        [PackageNames.Mock, MOCK],
        [PackageNames.MQTT, MQTT],
        [PackageNames.DPC, DPC],
        [PackageNames.Widget, WIDGET],
        [PackageNames.Technology, TECHNOLOGY],

        [PackageNames.TechnologyTopo, TECHNOLOGYTOPO],
        [PackageNames.Operation, OPERATION],
        [PackageNames.Sheet, SHEET],
        [PackageNames.VueCustomElement, VUECOMPONENTSPROVIDER],
        [PackageNames.Editor, Editor],
    ])

    /**
     * 注册provider
     * @param {registersMap} name 
     * @param {Class} provider 
     */
    registerProvider(name, provider) {
        if (this.hasProvider(name)) {
            console.warn(`provider ${name} is already registered`)
            return;
        }
        let $provider = new provider(this)
        // 实例化provider 
        this.providers.set(name, $provider);
    }

    // 检查是否已经注册
    hasProvider(name) {
        return this.providers.has(name);
    }

    // 
    /**
     * 注销provider
     * @param {string} name 
     */
    destroyProvider(name) {
        if (!this.hasProvider(name)) {
            console.warn(`provider ${name} is not registered`)
            return;
        }
        let provider = this.providers.get(name);
        provider.destroy && provider.destroy();
        this.providers.delete(name);
    }

    /**
     * 获取provider
     * @param {PackageNames} name 
     * @returns provider
     */
    getProvider(name) {
        if (!this.hasProvider(name)) {
            console.warn(`provider ${name} is not registered`)
            return null;
        }

        return this.providers.get(name);
    }


    /**
     * 获取所有provider
     * @returns {providers}
     */
    getProviders() {
        return this.providers;
    }

    /**
     * 插件安装
     * @param {function | object} callback 
     */
    plugInstall(callback) {
        if (typeof callback == 'object') {
            callback.install && callback.install.call(this, this)
        } else if (typeof callback == 'function') {
            callback.call(this, this)
        }
    }

    /**
     * 当做vue插件使用
     * @param {Vue} vue 
     */
    install(Vue) {
        /**
         * @type {Core}
         */
        Vue.prototype.$Core = this;
        /**
         * @type {AUTH}
         */
        Vue.prototype.$Auth = this.getProvider('Auth')
        /**
         * @type {APPLICATION}
         */
        Vue.prototype.$Application = this.getProvider('Application');
    }

}

const Core = new CORE();

if (!globalThis.$Core) {
    globalThis.$Core = Core;
    window.parent.postMessage({
        type: 'loaded',
        success: true,
        msg: '框架加载完成'
    }, '*')
}


export default Core